import React from 'react';
import styles from './styles.module.css';
import { CheckBox, RangeSlider, SmallSearch, Title, SearchFormLeft } from '../../components';
import cn from 'classnames';

const Filter = () => {
  return (
    <div className={styles.main}>
      <div className={cn([styles.section,styles.bgGray])}>
        <SearchFormLeft />
      </div>
      <Title medium bold text={'Filter'} background white padding/>
      <div className={styles.section}>
        <Title medium text={'Hotel Name'} bold />
        <SmallSearch />
      </div>
      <div className={styles.section}>
        <Title medium text={'Price'} bold topLine />
        <RangeSlider />
      </div>
      <div className={styles.section}>
        <Title medium text={'Popular Filters'} bold topLine />
        <div className={styles.count}>
          <CheckBox label={'Free Cancellation'} />
          <small>(24)</small>
        </div>
        <div className={styles.count}>
          <CheckBox label={'BreakFast Included'} />
          <small>(24)</small>
        </div>
      </div>
      <div className={styles.section}>
        <Title medium text={'Availability'} bold topLine />
        <div className={styles.count}>
          <CheckBox label={'Show available hotels only'} />
          <small>(24)</small>
        </div>
      </div>
      <div className={cn([styles.section, styles.stars])} >
        <Title medium text={'Star Rating'} bold topLine />
        <div className={styles.count}>
          <CheckBox label="&#9733; &#9733; &#9733; &#9733; &#9733;" />
          <small>(24)</small>
        </div>
        <div className={styles.count}>
          <CheckBox label="&#9733; &#9733; &#9733; &#9733; &#9734;" />
          <small>(24)</small>
        </div>
        <div className={styles.count}>
          <CheckBox label="&#9733; &#9733; &#9733; &#9734; &#9734;" />
          <small>(24)</small>
        </div>
        <div className={styles.count}>
          <CheckBox label="&#9733; &#9733; &#9734; &#9734; &#9734;" />
          <small>(24)</small>
        </div>
        <div className={styles.count}>
          <CheckBox label="&#9733; &#9734; &#9734; &#9734; &#9734;" />
          <small>(24)</small>
        </div>
      </div>
      <div className={styles.section}>
        <Title medium text={'Guest Rating'} bold topLine />
        <div className={styles.count}>
          <CheckBox label={'9+ Excellent'} />
            <small>(24)</small>
        </div>
        <div className={styles.count}>
          <CheckBox label={'8+ Very Good'} />
          <small>(24)</small>
        </div>
        <div className={styles.count}>
        <CheckBox label={'7+ Good'} />
          <small>(24)</small>
        </div>
        <div className={styles.count}>
          <CheckBox label={'6+ Fair'} />
          <small>(24)</small>
        </div>
      </div>
    </div>
  );
};
export default Filter;
